import React, { FC } from 'react'

import Container from '@Components/CMS/Container'
import { FactBox } from '@Components/CMS/FactBox'
import { RTEContent } from '@Components/RTEContent'
import { Block } from '@Generated/graphql'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'

interface FactBlockProps {
  factBlock: Block
  id?: string
}

const FactBlock: FC<FactBlockProps> = ({ factBlock, id }) => {
  const text = getRTEFieldText(factBlock.fields || [], 'text')
  if (!text) {
    return null
  }

  return (
    <Container id={id}>
      <FactBox>
        <RTEContent html={text} />
      </FactBox>
    </Container>
  )
}

export default FactBlock
